import React from 'react';
import classes from './DrawerToggle.css'

const drawerToggle = (props) => (
	<div onClick={props.toggleClicked} className={classes.DrawerToggle}>
		<div/>
		<div/>
		<div/>
	</div>
);

export default drawerToggle;


// WEBPACK FOOTER //
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.js